import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Picklist } from '../models/Picklist';


@Injectable({
  providedIn: 'root'
})
export class PicklistService {

  constructor(private http: HttpClient) {
  }

  public getPicklists(): Observable<Picklist[]> {
    return this.http.post<Picklist[]>('/api/framework/picklists/', null);
  }
}    